'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Send, Bot, Sparkles } from 'lucide-react';

const initialMessages = [
  {
    id: 'msg-001',
    role: 'tutor',
    text: "Hi Amara! 🌟 Ready to continue with Functions & Loops? You're doing great — 68% through Intro to Coding!",
    time: '2:31 PM',
  },
  {
    id: 'msg-002',
    role: 'student',
    text: 'Yes! I was confused about how return values work.',
    time: '2:32 PM',
  },
  {
    id: 'msg-003',
    role: 'tutor',
    text: "Great question! Think of a function like a vending machine 🎰 — you put something in (the input), it does work, then gives you something back (the return value). Want me to show you an example?",
    time: '2:32 PM',
  },
];

export default function StudentAITutorPanel() {
  const [messages, setMessages] = useState(initialMessages);
  const [input, setInput] = useState('');

  const sendMessage = () => {
    if (!input?.trim()) return;
    const userMsg = { id: `msg-${Date.now()}`, role: 'student', text: input, time: 'Now' };
    const tutorReply = {
      id: `msg-${Date.now() + 1}`,
      role: 'tutor',
      text: "That's a thoughtful question! Let me explain that step by step. In programming, every concept builds on the last — just like climbing the Tree of Life 🌳",
      time: 'Now',
    };
    setMessages((p) => [...p, userMsg, tutorReply]);
    setInput('');
  };

  return (
    <div className="bg-card border border-border rounded-2xl overflow-hidden flex flex-col" style={{ height: '400px' }}>
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3 border-b border-border bg-primary/5">
        <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center shrink-0">
          <Bot size={16} className="text-primary-foreground" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-foreground">Jara — Your AI Tutor</p>
          <p className="text-xs text-muted-foreground flex items-center gap-1">
            <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full" />
            Active · Intermediate mode
          </p>
        </div>
        <Link href="/ai-tutor-builder" className="p-1.5 rounded-lg hover:bg-muted transition-colors" title="Configure tutor">
          <Sparkles size={14} className="text-muted-foreground" />
        </Link>
      </div>
      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {messages?.map((msg) => (
          <div
            key={msg?.id}
            className={`flex ${msg?.role === 'student' ? 'justify-end' : 'justify-start'} chat-bubble-in`}
          >
            <div
              className={`max-w-[85%] px-3 py-2 rounded-xl text-sm leading-relaxed ${
                msg?.role === 'student' ?'bg-primary text-primary-foreground rounded-br-sm' :'bg-muted text-foreground rounded-bl-sm'
              }`}
            >
              <p>{msg?.text}</p>
              <p className={`text-xs mt-1 ${msg?.role === 'student' ? 'text-primary-foreground/70 text-right' : 'text-muted-foreground'}`}>
                {msg?.time}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Input */}
      <div className="px-4 py-3 border-t border-border flex items-center gap-2">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e?.target?.value)}
          onKeyDown={(e) => { if (e?.key === 'Enter') sendMessage(); }}
          placeholder="Ask Jara anything..."
          className="flex-1 px-3 py-2 bg-input rounded-lg text-sm text-foreground placeholder:text-muted-foreground outline-none focus:ring-2 focus:ring-ring transition-all"
        />
        <button
          onClick={sendMessage}
          disabled={!input?.trim()}
          className="p-2 bg-primary text-primary-foreground rounded-lg btn-scale hover:bg-primary/90 disabled:opacity-40 transition-all"
          aria-label="Send message"
        >
          <Send size={14} />
        </button>
      </div>
    </div>
  );
}